import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PortalManagementSubscriptionService } from 'src/app/features/portal/_services/management/portal-management-subscription.service';

/**
 * Links an already-provisioned, unclaimed circuit to a subscription that
 * doesn't have one yet - e.g. a customer who signed up online and got an
 * auto-generated account reference (like an MTDNX number) before their
 * field install, done separately, was ever linked back to them.
 */
@Component({
  selector: 'app-claim-circuit-dialog',
  templateUrl: './claim-circuit-dialog.component.html',
  styleUrls: ['./claim-circuit-dialog.component.scss']
})
export class ClaimCircuitDialogComponent {
  form: FormGroup = this.fb.group({
    device_reference: ['', Validators.required]
  });

  submitting = false;
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    public config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private pmss: PortalManagementSubscriptionService
  ) {}

  get subscription(): any {
    return this.config.data?.subscription;
  }

  onSubmit(): void {
    this.errorMessage = '';

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const subscriptionId = this.subscription?.id;
    if (!subscriptionId) {
      this.errorMessage = 'No subscription selected - please close and try again.';
      return;
    }

    this.submitting = true;
    this.pmss
      .claimCircuitForSubscription(subscriptionId, this.form.value.device_reference)
      .subscribe({
        next: (res) => {
          this.submitting = false;
          this.ref.close({ success: true, data: res?.data });
        },
        error: (error) => {
          this.submitting = false;
          this.errorMessage =
            error?.error?.detail || 'Failed to claim circuit. Please try again.';
        }
      });
  }

  closeDialog(): void {
    this.ref.close();
  }
}
